import script from "./DataProtectionOfficeArticles.vue?vue&type=script&setup=true&lang=js"
export * from "./DataProtectionOfficeArticles.vue?vue&type=script&setup=true&lang=js"

import "./DataProtectionOfficeArticles.vue?vue&type=style&index=0&id=c2fc48e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2fc48e4"]])

export default __exports__